export const environment = {
  production: true,
  apiUrl: 'https://api.innovagent.property/landlord/v1/'
};
